import { OPEN_ERROR_MODAL, CLOSE_ERROR_MODAL } from '../actions/types/index';

export default (
  state = {
    message: '',
    errorModal: false
  },
  action
) => {
  switch (action.type) {
    case OPEN_ERROR_MODAL:
      return { ...state, message: action.payload, errorModal: true };
    case CLOSE_ERROR_MODAL:
      return { ...state, errorModal: false };
    default:
      return state;
  }
};
